import { Checkbox, Product, Text } from "components/commons";
import { ProductCodeEnum } from "enums";
import { formatAmount } from "utils";
import { prettifyProductType } from "utils/pretty.utils";

export const mapDataToList = ({
  product,
  coloredProduct = true,
  onCheck,
  selected,
  disableAction = false,
}) => {
  let mapper = {
    select: (
      <Checkbox
        name={product?.name}
        value={selected?.includes(product.sku)}
        onChange={(name, { value }) => onCheck?.(product.sku)}
      />
    ),
    sku: <Text style={{ wordBreak: "break-all" }}>{product.sku || "--"}</Text>,
    productName:
      coloredProduct && Object.values(ProductCodeEnum).includes(product.sku) ? (
        <Product
          key={product.sku}
          grass={product.sku === ProductCodeEnum.GAS91}
          salsa={product.sku === ProductCodeEnum.GAS95}
          deepBlue={product.sku === ProductCodeEnum.GAS97}
          cheddar={product.sku === ProductCodeEnum.DIESEL}
        >
          {product.name}
        </Product>
      ) : (
        <Text style={{ wordBreak: "break-all" }}>{product.name || "--"}</Text>
      ),
    variant: <Text style={{ wordBreak: "break-all" }}>{product.variant || "--"}</Text>,
    productType: prettifyProductType(product?.type),
    productPrice: product?.amount ? formatAmount(product?.amount) : "--",
    amount: product?.amount ? formatAmount(product?.amount) : "--",
    category: <Text style={{ wordBreak: "break-all" }}>{product.category.name || "--"}</Text>,
  };
  if (disableAction) {
    delete mapper.select;
  }
  return mapper;
};

export const mapFilterToRequest = (filterState) => {
  const { productType, categoryIds, variants, ...fs } = filterState;

  if (productType?.value?.length > 0) {
    fs.type = productType?.value?.join(",");
  }

  if (productType?.isSelectedAll) {
    fs.type = undefined;
  }

  if (!categoryIds?.isSelectedAll) {
    fs.categoryIds = categoryIds?.value?.join(",");
  } else {
    fs.categoryIds = undefined;
  }

  if (!variants?.isSelectedAll) {
    fs.variants = variants?.value?.join(",");
  } else {
    fs.variants = undefined;
  }

  return fs;
};
